import { PORTAL } from "src/constants/AppConstants";
const appSettings = {
    'appId':'111',
    'appName':'ted'
}

export default appSettings;